{
  "en": {
    "keyword": {
      "motorhome": {
        "label": "motorhome",
        "label_plural": "motorhomes",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "motorhome",
          "fr": "motorise"
        }
      },
      "class-a": {
        "label": "Class A",
        "label_enhanced": "Class A Motorhome",
        "label_plural": "Class A",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "class-a",
          "fr": "classe-a"
        }
      },
      "class-b": {
        "label": "Class B",
        "label_enhanced": "Class B Campervan",
        "label_plural": "Class B",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "class-b",
          "fr": "classe-b"
        }
      },
      "class-c": {
        "label": "Class C",
        "label_enhanced": "Class C Motorhome",
        "label_plural": "Class C",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "class-c",
          "fr": "classe-c"
        }
      },
      "campervan": {
        "label": "campervan",
        "label_plural": "campervans",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "campervan",
          "fr": "campervan"
        }
      },
      "trailer": {
        "label": "trailer",
        "label_plural": "trailers",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "trailer",
          "fr": "roulotte"
        }
      },
      "fifth-wheel": {
        "label": "Fifth Wheel",
        "label_plural": "Fifth Wheel",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "fifth-wheel",
          "fr": "sellette"
        }
      },
      "travel-trailer": {
        "label": "travel trailer",
        "label_plural": "travel trailers",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "travel-trailer",
          "fr": "caravane-de-voyage"
        }
      },
      "toy-hauler": {
        "label": "toy hauler",
        "label_plural": "toy haulers",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "toy-hauler",
          "fr": "roulotte-cargo"
        }
      },
      "micro-trailer": {
        "label": "micro trailer",
        "label_plural": "micro trailers",
        "prefix": {
          "article": "a"
        },
        "slug": {
          "en": "micro-trailer",
          "fr": "mini-roulotte"
        }
      }
    }
  },
  "fr": {
    "keyword": {
      "motorise": {
        "label": "motorisé",
        "label_plural": "motorisés",
        "prefix": {
          "article": "un",
          "best": "meilleurs"
        },
        "slug": {
          "en": "motorhome",
          "fr": "motorise"
        }
      },
      "classe-a": {
        "label": "Classe A",
        "label_enhanced": "Classe A Motorisé",
        "label_plural": "Classe A",
        "prefix": {
          "article": "un",
          "best": "meilleurs"
        },
        "slug": {
          "en": "class-a",
          "fr": "classe-a"
        }
      },
      "classe-b": {
        "label": "Classe B",
        "label_enhanced": "Classe B Campervan",
        "label_plural": "Classe B",
        "prefix": {
          "article": "un",
          "best": "meilleurs"
        },
        "slug": {
          "en": "class-b",
          "fr": "classe-b"
        }
      },
      "classe-c": {
        "label": "Classe C",
        "label_enhanced": "Classe C Motorisé",
        "label_plural": "Classe C",
        "prefix": {
          "article": "un",
          "best": "meilleurs"
        },
        "slug": {
          "en": "class-c",
          "fr": "classe-c"
        }
      },
      "campervan": {
        "label": "campervan",
        "label_plural": "campervans",
        "prefix": {
          "article": "un",
          "best": "meilleurs"
        },
        "slug": {
          "en": "campervan",
          "fr": "campervan"
        }
      },
      "roulotte": {
        "label": "roulotte",
        "label_plural": "roulottes",
        "prefix": {
          "article": "une",
          "best": "meilleures"
        },
        "slug": {
          "en": "trailer",
          "fr": "roulotte"
        }
      },
      "sellette": {
        "label": "sellette",
        "label_plural": "sellettes",
        "prefix": {
          "article": "une",
          "best": "meilleures"
        },
        "slug": {
          "en": "fifth-wheel",
          "fr": "sellette"
        }
      },
      "caravane-de-voyage": {
        "label": "caravane de voyage",
        "label_plural": "caravanes de voyage",
        "prefix": {
          "article": "une",
          "best": "meilleures"
        },
        "slug": {
          "en": "travel-trailer",
          "fr": "caravane-de-voyage"
        }
      },
      "roulotte-cargo": {
        "label": "roulotte cargo",
        "label_plural": "roulottes cargo",
        "prefix": {
          "article": "une",
          "best": "meilleures"
        },
        "slug": {
          "en": "toy-hauler",
          "fr": "roulotte-cargo"
        }
      },
      "mini-roulotte": {
        "label": "mini-roulotte",
        "label_plural": "mini-roulottes",
        "prefix": {
          "article": "une",
          "best": "meilleures"
        },
        "slug": {
          "en": "micro-trailer",
          "fr": "mini-roulotte"
        }
      }
    }
  }
}
